<div class="modal-body">
  @if (notificationProfile() || TemplateType.Canceled) {
    <div class="mb-3">
      <span
        [innerHTML]="
          'reports.approve.prepareEmail.title'
            | translate
              : {
                  notificationProfileName:
                    notificationProfile()?.name ?? TemplateType.Canceled,
                }
        "
      ></span>
    </div>

    @if (
      templateType() === TemplateType.NotQualified ||
      templateType() === TemplateType.Canceled
    ) {
      <label class="label-primary ps-1">{{
        'reports.approve.prepareEmail.createCustomEmailNotQualifiedMessage'
          | translate
      }}</label>
    } @else {
      <div class="row">
        <div class="col-12 col-md-6">
          <form class="row form-group" [formGroup]="sendEmailForm" novalidate>
            @if (templateType() === TemplateType.HighRisk) {
              <div class="label form-control-label col-12 mb-2">
                <label class="label-primary ps-1" for="reason">{{
                  'reports.approve.prepareEmail.highRiskReason' | translate
                }}</label>
                <input
                  class="form-control"
                  formControlName="reason"
                  name="reason"
                  id="reason"
                  type="text"
                  [placeholder]="
                    'reports.approve.prepareEmail.placeholders.highRiskReason'
                      | translate
                  "
                  (keydown)="error.set(null)"
                />
              </div>
            }

            <div class="label form-control-label col-12 mb-2">
              <label class="label-primary ps-1" for="subject">{{
                'reports.approve.prepareEmail.mailSubject' | translate
              }}</label>
              <input
                class="form-control"
                formControlName="subject"
                name="subject"
                id="subject"
                type="text"
                [placeholder]="
                  'reports.approve.prepareEmail.placeholders.mailSubject'
                    | translate
                "
              />
            </div>
            <div class="label form-control-label col-12">
              <label class="label-primary ps-1" for="body">{{
                'reports.approve.prepareEmail.mailBody' | translate
              }}</label>
              <textarea
                rows="25"
                class="form-control"
                formControlName="body"
                name="body"
                id="body"
                type="text"
                [placeholder]="
                  'reports.approve.prepareEmail.placeholders.mailBody'
                    | translate
                "
              ></textarea>
            </div>
          </form>
        </div>
        <div class="col-12 col-md-6">
          <div class="row mt-3">
            <div class="col-12">
              <div class="d-flex flex-row mb-2">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'reports.approve.prepareEmail.placeholders.to' | translate
                  "
                  [formControl]="toEmailInput"
                />
                <button
                  class="icon-btn icon-btn-lg ms-2"
                  placement="top"
                  triggers="hover"
                  [ngbTooltip]="
                    'reports.approve.prepareEmail.tooltips.to' | translate
                  "
                  [disabled]="!toEmailInput.value || toEmailInput.invalid"
                  (click)="addEmailByType(RecipientType.TO)"
                >
                  <i class="fa-light fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              @if (toEmailInput.invalid && toEmailInput.touched) {
                @if (toEmailInput.errors?.email) {
                  <span class="caption text-danger">{{
                    'common.errors.emailIsInvalid' | translate
                  }}</span>
                }
              }
            </div>
            <div class="col-12">
              <app-data-table
                [configuration]="toDataTableConfiguration"
              ></app-data-table>
            </div>
          </div>
          <hr />
          <div class="row mt-5">
            <div class="col-12">
              <div class="d-flex flex-row mb-2">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'reports.approve.prepareEmail.placeholders.cc' | translate
                  "
                  [formControl]="ccEmailInput"
                />
                <button
                  class="icon-btn icon-btn-lg ms-2"
                  placement="top"
                  triggers="hover"
                  [ngbTooltip]="
                    'reports.approve.prepareEmail.tooltips.cc' | translate
                  "
                  [disabled]="!ccEmailInput.value || ccEmailInput.invalid"
                  (click)="addEmailByType(RecipientType.CC)"
                >
                  <i class="fa-light fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              @if (ccEmailInput.invalid && ccEmailInput.touched) {
                @if (ccEmailInput.errors?.email) {
                  <span class="caption text-danger">{{
                    'common.errors.emailIsInvalid' | translate
                  }}</span>
                }
              }
            </div>

            <div class="col-12">
              <app-data-table
                [configuration]="ccDataTableConfiguration"
              ></app-data-table>
            </div>
          </div>
          <hr />
          <div class="row mt-5">
            <div class="col-12">
              <div class="d-flex flex-row mb-2">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'reports.approve.prepareEmail.placeholders.bcc' | translate
                  "
                  [formControl]="bccEmailInput"
                />
                <button
                  class="icon-btn icon-btn-lg ms-2"
                  placement="top"
                  triggers="hover"
                  [ngbTooltip]="
                    'reports.approve.prepareEmail.tooltips.bcc' | translate
                  "
                  [disabled]="!bccEmailInput.value || bccEmailInput.invalid"
                  (click)="addEmailByType(RecipientType.BCC)"
                >
                  <i class="fa-light fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              @if (bccEmailInput.invalid && bccEmailInput.touched) {
                @if (bccEmailInput.errors?.email) {
                  <span class="caption text-danger">{{
                    'common.errors.emailIsInvalid' | translate
                  }}</span>
                }
              }
            </div>
            <div class="col-12">
              <app-data-table
                [configuration]="bccDataTableConfiguration"
              ></app-data-table>
            </div>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="mb-0">
      {{
        'reports.approve.prepareEmail.pleaseAddNotificationProfiles' | translate
      }}
    </div>
  }

  @if (error()) {
    <div class="caption text-danger">
      {{ error() }}
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-clear me-2" (click)="cancel()">
    <span>{{ 'common.buttons.btnCancel' | translate }}</span>
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="
      !notificationProfile ||
      templateType() === TemplateType.NotQualified ||
      templateType() === TemplateType.Canceled
    "
    (click)="previewEmail()"
  >
    {{ 'reports.approve.buttons.previewEmail' | translate }}
  </button>
</div>
